import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { Link, Outlet, useLocation } from "react-router-dom";
import "./Home.css"; 
import logo from "./img/logo.png";

const MainDash = () => {
  const { logout } = useContext(AuthContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    document.body.className = darkMode ? "dark-mode" : "light-mode";
  }, [darkMode]);

  const isHome = location.pathname === "/" || location.pathname === "/MainDash";

  return (
    <div className="home-container">
      {/* Navbar */}
      <nav className="navbar">
        <div className="logo">
          <img src={logo} alt="Logo" className="logo-img" />
        </div>

        <div className={`menu-items ${isMenuOpen ? "active" : ""}`}>
          <ul>
            <li><Link to="/"><button className="nav-button">Home</button></Link></li>
            <li><Link to="/MainDash/Team"><button className="nav-button">Team</button></Link></li>
            <li><Link to="/MainDash/Contactus"><button className="nav-button">Contact Us</button></Link></li>
            <li><Link to="/MainDash/Aboutus"><button className="nav-button">About Us</button></Link></li>
            <li><Link to="/MainDash/Login"><button className="nav-button">Login</button></Link></li>
            <li>
              <button 
                onClick={() => setDarkMode(!darkMode)} 
                className="nav-button">
                {darkMode ? "☀️ Light" : "🌙 Dark"}
              </button>
            </li>
          </ul>
        </div>

        <div className="hamburger" onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </nav>

      {/* Main Content */}
   <div className="dashboard-content">
  <div className="outlet-wrapper">
    {isHome ? (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <img src={logo} alt="Welcome" style={{ width: "200px", marginBottom: "20px" }} />
<h2 className="welcome-text">Welcome to Adnyatech.com</h2>
      </div>
    ) : (
      <Outlet />
    )}
  </div>
</div>


    </div>
  );
};

export default MainDash;
